import { useEffect, useState, ReactNode } from "react";

import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";
import Lottie from "react-lottie";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import { wacToken } from "@/libraries/design/foundations";

import getToDoneAnimation from "./lotties/get-to-done.json";
import { messages } from "./messages";

const containerCss = css({
    padding: "0 60px"
});

const lottieContainerCss = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    maxWidth: "58rem",
    marginInlineStart: "auto",
    marginInlineEnd: "auto",
    marginBlockStart: "1.25rem",
    marginBlockEnd: "-1.5rem",
    [media.below.md]: {
        display: "none"
    }
});

const mobileHeaderCss = css({
    display: "none",
    fontFamily: token("font.family.brand.heading"), // Charlie Display
    fontWeight: 800,
    fontSize: "2.5rem",
    lineHeight: "2.9rem",
    textAlign: "center",
    // eslint-disable-next-line local/ensure-wac-token-usage
    color: "#000",
    marginBlockStart: "63px",
    [media.below.md]: {
        display: "block"
    }
});

const headerHighlightCss = css({
    backgroundColor: wacToken("color.extended.lime300"),
    padding: "0.1rem 0.6rem",
    display: "inline-block",
    textTransform: "uppercase",
    fontWeight: 500,
    borderRadius: "0.4rem",
    fontSize: "2rem",
    lineHeight: "2.5rem"
});

const subHeaderCss = css({
    fontFamily: token("font.family.brand.body"), // Charlie Text
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    textAlign: "center",
    // eslint-disable-next-line local/ensure-wac-token-usage
    color: "#000",
    margin: "8px 0 0 0"
});

export const PaidJiraAiHeader = () => {
    const [animationStarted, setAnimationStarted] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setAnimationStarted(true);
        }, 400);

        return () => clearTimeout(timer);
    }, []);

    const lottieOptions = {
        loop: false,
        autoplay: true,
        animationData: getToDoneAnimation,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <div css={containerCss}>
            <div css={lottieContainerCss}>
                <Lottie options={lottieOptions} isPaused={!animationStarted} />
            </div>
            <h1 css={mobileHeaderCss}>
                <FormattedMessage
                    {...messages.getToDoneFaster}
                    values={{
                        highlight: (str: ReactNode) => (
                            <span css={headerHighlightCss}>{str}</span>
                        )
                    }}
                />
            </h1>
            <p css={subHeaderCss}>
                <FormattedMessage {...messages.aiPoweredProjectManagement} />
            </p>
        </div>
    );
};
